import { TFasterPayoutStatus } from '../../../../../api/src';
import { TFunction } from 'i18next';
import { ReactNode } from 'react';

type Toasts = {
  success: (description?: ReactNode, title?: ReactNode) => void;
  error: (description?: ReactNode, title?: ReactNode) => void;
};

export const showFasterPayoutStatusToast = (
  status: TFasterPayoutStatus,
  toasts: Toasts,
  t: TFunction<['makeFasterPayout']>,
) => {
  const ns = { ns: 'makeFasterPayout' as const };
  if (status === 'Success') {
    toasts.success(t('form.successSuccess', ns));
    return;
  }
  if (status === 'Rejected') {
    toasts.error(t('form.successRejected', ns));
  }
};
